import React, { useEffect, useState } from 'react';
import {
    Modal,
    Box,
    Typography,
    TableContainer,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    IconButton,
    Button,
    TextField,
    InputAdornment,
    OutlinedInput
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { TTestAsset } from '../../../../../types';
import { Clear, Search } from '@mui/icons-material';
interface Props {
    data: TTestAsset[];
    onClose: ()=>void;
    open:boolean;
    searchAssets:(searchQuery:string)=> void;
}
const SelectAssetsModal: React.FC<Props>  = ({ data, onClose,open,searchAssets }) => {
    const [selectedAssets, setSelectedAssets] = useState(data);
    const [searchQuery,setSearchQuery] = useState<string>('');
    const [quantities, setQuantities] = useState<any>([]);
    const [removeQuery,setRemoveQuery] = useState(false);
    useEffect(()=>{
        setQuantities(data.map(asset => ({ assetName: asset.assetName, quantity: 0 })));
    },[])
      const handleIncrement = (index:number) => {
        const updatedQuantities = [...quantities];
        updatedQuantities[index].quantity++;
        setQuantities(updatedQuantities);
      };
    
      const handleDecrement = (index:number) => {
        const updatedQuantities = [...quantities];
        if (updatedQuantities[index].quantity > 0) {
          updatedQuantities[index].quantity--;
          setQuantities(updatedQuantities);
        }
      };

    const handleDone = () => {
        onClose();
    };
    const handleRemove = ()=>{
        setSearchQuery('');
        searchAssets('');
        setRemoveQuery(false);
    }
const handleSearch = ()=>{
    searchAssets(searchQuery);
    setRemoveQuery(true);
}
    return (
        <Modal open={open} onClose={onClose}>
        <Box sx={{ 
      position: 'absolute', 
      top: '50%', 
      left: '50%', 
      transform: 'translate(-50%, -50%)', 
      backgroundColor: 'white', 
      padding: '20px', 
      borderRadius: open ? '10px' : '0',  
      border: 'none',
      
      '&:focus': { border: 'none', outline: 'none' },
      /* Style scrollbar */
      
    }}>
        <Typography sx={{textAlign:'center',fontWeight:'600',fontSize:'20px',mb:1}}>Select Assets</Typography>
        <OutlinedInput
            id="outlined-adornment-password"
            // type={showPassword ? 'text' : 'password'}
            value={searchQuery}
            onChange={(e)=>setSearchQuery(e.target.value)}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={searchQuery ? handleRemove:handleSearch}
                //   onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {searchQuery ? <Clear/> :<Search/>}
                </IconButton>
              </InputAdornment>
            }
            placeholder="Search Asset"
          />
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Quantity</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((asset, index) => (
                <TableRow key={index}>
                  <TableCell>{asset.assetName}</TableCell>
                  <TableCell>
                    <IconButton onClick={() => handleDecrement(index)}><RemoveIcon /></IconButton>
                    {quantities[index]?.quantity}
                    <IconButton onClick={() => handleIncrement(index)}><AddIcon /></IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          {/* <button onClick={handleDone}>Done</button> */}
        </Box>
      </Modal>
    );
};

export default SelectAssetsModal;
